import { DotsAccordion, DotsAccordionTab } from "dots-ui/dotsAccordion";
import { CreationClassGroupedRightsViewModel } from "../../../generated/data-contracts";
import { isMobileView } from "../../shared/appStates/appStates";
import { DelegatedRightsItem } from "./DelegatedRightsItem";

interface IDelegatedRightsGroupProps {
  delegatedRights: CreationClassGroupedRightsViewModel[];
}

export function DelegatedRightsGroup(
  props: Readonly<IDelegatedRightsGroupProps>,
) {
  const { delegatedRights } = props;

  const renderTabHeader = (group: CreationClassGroupedRightsViewModel) => {
    return (
      <div className="tab-roles-header grid">
        <div className="tab-roles-header-title col-4">{group.name}</div>
        <div className="tab-roles-header-roles col-8">
          {group?.roles?.map((r) => `${r.name}`).join(", ")}
        </div>
      </div>
    );
  };

  const renderTabs = () => {
    return delegatedRights.map((dr, i) => {
      return (
        <DotsAccordionTab key={i} headerTemplate={renderTabHeader(dr)}>
          <div className="tab-roles-content-rights">
            <div className="tab-roles-toggle-spacer"></div>
            <div className="tab-roles-content-rights-wrapper grid">
              {!isMobileView.value && (
                <div className="tab-roles-column-spacer col-4"></div>
              )}
              <div className={isMobileView.value ? "col-12" : "col-8"}>
                {dr.rights?.map((item) => {
                  return (
                    <DelegatedRightsItem
                      key={item.id}
                      item={item}
                      isAssigned={true}
                    />
                  );
                })}
                {dr.rightsNotAssigned?.map((item) => {
                  return (
                    <DelegatedRightsItem
                      key={item.id}
                      item={item}
                      isAssigned={false}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </DotsAccordionTab>
      );
    });
  };

  return (
    <DotsAccordion
      className="avis-delegated-rights-group"
      severity="none"
      multiple
      toggleIconPosition="start"
      tabs={renderTabs()}
    />
  );
}
